import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Notification } from '../../values/Notification';
import { ActionTypes } from '../ActionTypes';

const initialState: {
  visibleNotifications: Notification[];
} = {
  visibleNotifications: [],
};

export const notificationsSlice = createSlice({
  // available at state.composer.notificaitons
  name: 'notifications',
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<Notification>) => {
      state.visibleNotifications.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(ActionTypes.QUEUE_NOTIFICATION, (state, action) => {
      state.visibleNotifications.push(
        Notification.new((action as any).payload)
      );
    });
  },
});

export const selectVisibleNotifications = (state) => {
  if (!state.composer) {
    // old state, remove when NotificationStore is gone
    return state.visibleNotifications;
  }

  return state.composer[notificationsSlice.name].visibleNotifications;
};

export const { addNotification } = notificationsSlice.actions;
